import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import EfLink from '@elem/ui/ef-link';
import { useEffect, useState } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useRouter } from 'next/router';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import gtm from '@/utils/gtm';

interface ItemType {
    img: string[];
    label: string;
    title: string;
    desc: string[];
    price: number;
    compareAtPrice: number;
    inventory: number;
    buy_link: string;
    tab: string;
    productId?: string;
    variantId?: string;
}
export default function M() {
    const { t } = useLang('bkw');
    const { locale = 'de' } = useRouter();
    const items_static: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738908504669/13_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738908504091/13_1_M.jpg'],
            label: t('M_item1_label'),
            title: t('M_item1_title'),
            desc: [t('M_item1_desc1'), t('M_item1_desc2')],
            price: 0,
            compareAtPrice: 0,
            inventory: 0,
            buy_link: 'https://de.ecoflow.com/products/450w-rigid-solar-panel?variant=53659696791887',
            tab: t('M_item1_tab'),
            productId: '14953711993213',
            variantId: '55153031086461',
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738908505035/13_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1739181874660/13_2_M.jpg'],
            label: t('M_item2_label'),
            title: t('M_item2_title'),
            desc: [t('M_item2_desc1'), t('M_item2_desc2'), t('M_item2_desc3')],
            price: 0,
            compareAtPrice: 0,
            inventory: 0,
            buy_link: 'https://de.ecoflow.com/products/balkonkraftwerk-600w-800w-fur-garten',
            tab: t('M_item2_tab'),
            productId: '8633163415887',
            variantId: '48115329368399',
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738908505600/13_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738908505419/13_3_M.jpg'],
            label: t('M_item3_label'),
            title: t('M_item3_title'),
            desc: [t('M_item3_desc1'), t('M_item3_desc2'), t('M_item3_desc3')],
            price: 0,
            compareAtPrice: 0,
            inventory: 0,
            buy_link: 'https://de.ecoflow.com/products/balkonkraftwerk-600w-800w-fur-balkon-des-hauses',
            tab: t('M_item3_tab'),
            productId: '8633212993871',
            variantId: '48115388154191',
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738908504282/13_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738908505224/13_4_M.jpg'],
            label: t('M_item4_label'),
            title: t('M_item4_title'),
            desc: [t('M_item4_desc1'), t('M_item4_desc2'), t('M_item4_desc3')],
            price: 0,
            compareAtPrice: 0,
            inventory: 0,
            buy_link: 'https://de.ecoflow.com/products/balkonkraftwerk-600w-800w-fur-wand',
            tab: t('M_item4_tab'),
            productId: '8633184190799',
            variantId: '48115411255631',
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1738908504482/13_5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738908504850/13_5_M.jpg'],
            label: t('M_item5_label'),
            title: t('M_item5_title'),
            desc: [t('M_item5_desc1'), t('M_item5_desc2')],
            price: 682,
            compareAtPrice: 785,
            inventory: 0,
            buy_link: 'https://de.ecoflow.com/pages/powerstream?tab=diy',
            tab: t('M_item5_tab'),
            // productId: '8633212993871',
            // variantId: '48115388154191',
        },
    ];
    const [items, setItems] = useState<ItemType[]>(items_static);
    const [active, setActive] = useState<number>(0);

    const handleClickTab = (item: ItemType, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'EcoFlow – Flexible Energie für jede Anwendung',
            button_name: item.tab,
        });
    };

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(items_static?.filter((item: any) => item?.variantId)));
        const restArr = JSON.parse(JSON.stringify(items_static?.filter((item: any) => !item?.variantId)));
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].price = res?.data?.price;
                        tempArr[k].compareAtPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? 0;
                        // tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setItems(JSON.parse(JSON.stringify([...tempArr, ...restArr])));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="bkw-M" className={`bkw-M bkw-box ${css['bkw-M']}`}>
            <EfSpec />
            <div className="info">
                <h3 className="title">
                    {t.rich('M_title', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </h3>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="item-img">
                            <EfImg pc={item?.img[0]} h5={item?.img[1]} />
                        </div>
                        <div className="item-info">
                            <span className="item-label">{item.label}</span>
                            <p className="item-title">{item.title}</p>
                            <ul className="item-lists">
                                {item.desc.map((desc: string, m: number) => (
                                    <li className="item-desc" key={m}>
                                        {desc}
                                    </li>
                                ))}
                            </ul>
                            <div className="item-price">
                                <span className="price">{FormatMoneyLocal(item.price, locale)}</span>
                                {item.price !== item.compareAtPrice && <span className="compareAtPrice">{FormatMoneyLocal(item.compareAtPrice, locale)}</span>}
                            </div>
                            <EfLink className="item-buy" href={item.buy_link}>
                                {t('Common_buy')}
                            </EfLink>
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items.map((item: ItemType, k: number) => (
                    <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleClickTab(item, k)}>
                        {item.tab}
                    </li>
                ))}
            </ul>
            <EfSpec />
        </div>
    );
}
